<script setup>
import { computed } from "vue";

const props = defineProps({
  icon: { type: String, required: true },
  source: { type: String, default: "fas" },
  color: { type: String, default: null },
  size: { type: String, default: null },
});

const color = computed(() => {
  if (props.color === "danger") {
    return "text-danger";
  } else if (props.color === "success") {
    return "text-success";
  }

  return null;
});

const size = computed(() => {
  if (props.size === "small") {
    return `btn-sm`;
  } else if (props.size === "large") {
    return `btn-lg`;
  }

  return null;
});
</script>

<template>
  <i v-if="source === 'material'" :class="['material-icons', size, color]">{{
    icon
  }}</i>
  <i v-else :class="[`fas fa-${icon}`, size, color]"></i>
</template>
